import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { PauseAdService } from 'tag/ts/tag/ads/pause/PauseAdService';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
export class TagAPI extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'TagAPI'
        });
    }
    get namespace() {
        return this.params?.TAG?.namespace?.TAG;
    }
    get OUT() {
        return {
            tagAction: (data, returnValue = false) => {
                switch (returnValue) {
                    case false:
                        this.utils.API.executeCallback('tagAction', this.namespace, data);
                        break;
                    case true:
                        return this.utils.API.executeCallback('tagAction', this.namespace, data, true);
                }
            },
            checkContext: (context) => {
                return this.utils.API.executeCallback('checkContext', this.namespace, context, true);
            }
        };
    }
    get IN() {
        return {
            reset: () => {
                this?.logger?.log('IN:', 'method: reset');
                return new Promise((resolve, reject) => {
                    this?.logger?.log('IN:', 'method:', 'reset:', 'dispatch:', TagEvent.ON_API_RESET_TAG_REQUEST);
                    this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_API_RESET_TAG_REQUEST, this.tag, {
                        promiseResolve: resolve,
                        promiseReject: reject
                    }, this, this.name));
                });
            },
            getPauseAd: (type) => {
                return PauseAdService.getPauseAd(this.tag, type);
            },
            getDeviceCapabilities: () => {
                return this.tag.controller?.playerManager?.playerAdapter?.getDeviceCapabilities();
            }
        };
    }
}
